var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEdge = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -8)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: 0.6,
    transform: "translate(37.838194 23.575736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-17.5 7-10-10 2-2 10 10z",
    fill: "#b9770e",
    fillOpacity: 0.990196,
    stroke: "#986005"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-26 .5h-1l-1-1v-1l3.5-3.5 3-1 1 1z",
    fill: "#d5d5d5",
    stroke: "#717171"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2.511901,
    transform: "matrix(.23888159 0 0 .23884426 24.684672 13.886298)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-35.438573 40.244016s18.020569-18.033655 18.199486-18.212697c.05144-.222014.393619-2.16821.393619-2.16821.0255-.109664.09125-.205453.184286-.269013l5.372891-3.502527c.07604-.05192.16371-.07744.251379-.07744.115402 0 .229909.04476.316236.131149l2.0785747 2.080032c.1547644.154424.1748924.39837.04786.576518l-3.6794367 5.377108c-.0662.09265-.165052.156662-.276428.179043 0 0-1.835694.260059-2.068733.307059-.189653.189338-18.194121 18.207325-18.194121 18.207325-.08409.08415-.197256.131149-.316236.131149-.11898 0-.232592-.047-.316237-.131149l-1.993588-1.994985c-.174445-.175462-.174445-.458798.000487-.633365z",
    fill: "#d5d5d5",
    stroke: "#717171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-61.565894 61.279774 16.753833-16.766031c.88922-.889843 1.985537-1.355355 3.156105-1.355355.220069 0 .444609.03581.669151.06893.227225-.226936 1.205009-1.205854 1.383927-1.384897.02728-.29542.328314-3.594288.328314-3.594288.0022-.02372.0063-.047.01207-.07027.122111-.478939.412405-.81375.795288-.918937.08364-.02283.16863-.03402.254063-.03402.308185 0 .624869.145024.898165.418959l7.099447 7.105321c.349337.349581.489786.769885.384672 1.153036-.105114.383152-.439689.674098-.918742.796294-.02326.0063-.04652.01029-.07023.01208 0 0-3.295659.301688-3.590873.328097-.178918.179042-1.156702 1.15796-1.38348 1.385345.209781 1.419363-.228566 2.77248-1.285969 3.82749l-16.754281 16.766031c-.901297.901929-2.009244 1.378631-3.204412 1.378631-1.414343 0-2.851945-.660222-4.048903-1.857571-2.275831-2.277874-2.47264-5.262967-.478157-7.258849z",
    fill: "#fce94f",
    stroke: "#c4a000"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#5c5c5c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.5 14h-12.5l-5 15",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.5 11.5h5v5h-5z",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.5 16.5 5-5",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.5 11.5 5 5",
    fill: "none"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEdge, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edge.2aa8d3ce.svg";
export { ForwardRef as ReactComponent };